// core
import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'page-bad-request',
  templateUrl: './page-bad-request.component.html',
  styleUrls: ['./page-bad-request.component.scss']
})
export class PageBadRequestComponent implements OnInit {
  domain: string = window.location.host;
  partner: string = 'open';
  termsLink: string = '';
  privacyLink: string = '';
  updateBrand: any = {};
  brandEndpoint: string = '';

  footerLinksArray: any = {
    ahm: {
      terms: 'https://www.beopen.com/terms',
      privacy: 'https://ahm.com.au/car-and-home-insurance/privacy-policy'
    },
    bupa: {
      terms: 'https://www.beopen.com/terms',
      privacy: 'https://www.beopen.com/terms'
    },
    huddle: {
      terms: 'https://www.huddleinsurance.com/au-legal/terms-of-use',
      privacy: 'https://www.huddleinsurance.com/au-legal/privacy'
    },
    tapi: {
      terms: 'https://insurance.withtapi.co.nz/terms-and-conditions',
      privacy: 'https://insurance.withtapi.co.nz/terms-and-conditions'
    },
    slingshot: {
      terms: 'https://www.slingshot.co.nz/terms-and-conditions/insurance',
      privacy: 'https://www.slingshot.co.nz/privacy-policy'
    },
    wearesosure: {
      terms: 'https://wearesosure.com/about/social-insurance/terms',
      privacy: 'https://wearesosure.com/about/social-insurance/privacy'
    },
    open: {
      terms: 'https://www.beopen.com/terms',
      privacy: 'https://ahm.com.au/car-and-home-insurance/privacy-policy'
    }
  };

  ngOnInit(): void {
    if (this.domain.indexOf('ahm') > -1) {
      this.partner = 'ahm';
    }
    if (this.domain.indexOf('bupa') > -1) {
      this.partner = 'bupa';
    }
    if (this.domain.indexOf('huddle') > -1) {
      this.partner = 'huddle';
    }
    if (this.domain.indexOf('tapi') > -1) {
      this.partner = 'tapi';
    }
    if (this.domain.indexOf('wearesosure') > -1) {
      this.partner = 'wearesosure';
    }
    if (this.domain.indexOf('slingshot') > -1) {
      this.partner = 'slingshot';
    }

    this.termsLink = this.footerLinksArray[this.partner].terms;
    this.privacyLink = this.footerLinksArray[this.partner].privacy;
  }
}
